<template>
  <div ref="bh" id="brand" class="brand-honor" @wheel="handleMouseWheel">
    <div class="brand-honor-header">
      <div class="title">
        {{ $theme ? '品牌荣誉' : 'BRAND HONOR' }}
      </div>
      <div class="subTitle">
        {{ $theme ? '专业汇聚价值，价值成就品牌' : 'Professional convergence value, value achievements brand' }}
      </div>
    </div>
    <honorary-certificate ref="hc"></honorary-certificate>
    <standard-lead ref="sl"></standard-lead>
    <patent-certificate ref="pc"></patent-certificate>
    <Cooperation ref="co"></Cooperation>
    <core ref="ct"></core>
    <Partner ref="pn" :direction="direction"></Partner>
    <enterprise-qualification ref="eq"></enterprise-qualification>
    <ModelSix @toTop="backToTop"></ModelSix>
  </div>
</template>

<script>
import HonoraryCertificate from './components/honorary-certificate/Index.vue'
import StandardLead from './components/standard-lead/Index.vue'
import Cooperation from './components/cooperation/Index.vue'
import Core from './components/core/Index.vue'
import Partner from './components/partner/Index.vue'
import ModelSix from "@/views/home/components/model-six/Index.vue";
import PatentCertificate from './components/patent-certificate/Index.vue'
import EnterpriseQualification from './components/enterprise-qualification/Index.vue'

export default {
  name: 'BrandHonor',
  components: {
    HonoraryCertificate,
    StandardLead,
    Cooperation,
    Core,
    Partner,
    ModelSix,
    PatentCertificate,
    EnterpriseQualification
  },
  data() {
    return {
      showHeader: true,
      direction: 2,
      isFixed: false,
      // showBack: false,
      // activeTab: 1,
      // tabList: [
      //   {
      //     id: 1,
      //     name: '相关获奖',
      //     top: 878,
      //   },
      //   // {
      //   //   id: 1,
      //   //   name: '自主知识产权',
      //   //   top: 400,
      //   // },
      //   {
      //     id: 2,
      //     name: '标准引领',
      //     top: 1970,
      //   }, {
      //     id: 3,
      //     name: '产学研合作',
      //     top: 3050,
      //   }, {
      //     id: 4,
      //     name: '核心技术',
      //     top: 3987,
      //   }, {
      //     id: 5,
      //     name: '合作伙伴',
      //     top: 4437,
      //   }
      // ]
    }
  },
  methods: {
    // getScroll() {
    //   // let scrollTop = e.target.scrollTop;
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    //   // console.log(scrollTop)
    //   this.isFixed = scrollTop > 396
    //   this.showBack = scrollTop > 500
    //   if (scrollTop < this.tabList[0].top) {
    //     this.activeTab = 1
    //   } else if (scrollTop >= this.tabList[4].top) {
    //     this.activeTab = 5
    //   } else {
    //     for (let i = 0; i < 4; i++) {
    //       if (scrollTop >= this.tabList[i].top && scrollTop < this.tabList[i + 1].top) {
    //         this.activeTab = i + 1
    //         return
    //       }
    //     }
    //   }
    // },
    // changeTab(tab) {
    //   this.activeTab = tab.id
    //   window.scrollTo({left: 0, top: this.tabList.find(({id}) => id === tab.id).top, behavior: 'smooth'})
    // },
    getScroll() {
      const element = document.getElementById("brand");
      // if (!element) return
      let scrollTop_ = element.scrollTop;
      this.showHeader = scrollTop_ < 50
      // var scrollHeight = element.scrollHeight;
      // var clientHeight = element.clientHeight;
      // if (scrollTop_ + clientHeight >= scrollHeight) {
      // //  页面已滚动到底部
      // this.showHeader = false;
      // } else {
      //   this.showHeader = true;
      // }
    },
    backToTop() {
      document.getElementById('brand').scrollTo({left: 0, top: 0, behavior: 'smooth'})
    },
    handleMouseWheel(e) {
      const {deltaY} = e
      this.direction = deltaY > 0 ? 2 : 3
    }
  },
  watch: {
    showHeader(val) {
      this.$bus.$emit("change-show-header", val);
    },
  },
  mounted() {
    const element = document.getElementById("brand");
    element.addEventListener('scroll', this.getScroll, true);
  },
  beforeDestroy() {
    const element = document.getElementById("brand");
    element.removeEventListener('scroll', this.getScroll);
  },
}
</script>
<style lang="scss" scoped>
@import "./Index.scss";
</style>
